<template>
  <div class="app-change-payment-change-wrapper">
    <SimonModal
      :is-visible="showModal"
      @hide="showModal = false"
      id="change-customer-payment-modal"
      disabled-close
      show-footer-buttons
      @btnLeft="prev"
      @btnRight="next"
      :disabled-btn-right="loading_"
      btn-right-title="Speichern"
      size="large"
      @shown="onModalShown"
    >
      <template v-slot:modalTitle>
        <slot name="headerModal"></slot>
      </template>
      <slot name="txtChangePaymentBankAccountInfo"></slot>
      <b-form
        class="change-payment-form"
        :id="'form' + _uid">
        <PaymentBankAccount
          :iban.sync="paymentInformation_.iban"
          :owner.sync="paymentInformation_.owner"
          :invalid.sync="bankAccountInvalid"
          @focused="onFormFocus"
          ref="bankAccount"
        >
          <template v-for="slot in possibleChildSlotsFor('Bank')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </PaymentBankAccount>
        <div class="error-box" v-if="showBackendError()" v-html="getBackendErrorMessage">
          <slot name="txtValidationErrorTechnical"></slot>
        </div>
      </b-form>
      <slot name="txtAfterButton"></slot>
    </SimonModal>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import { validationMixin } from 'vuelidate'
import syncProperty from '@/mixins/syncProperty'
import PaymentBankAccount from '@/components/process/generic/Payment/flash/BankAccountSmart.vue'
import validationFlow from '@/mixins/validators/validationFlow'
import { stepName as nextStep } from '@/components/process/generic/Success.vue'
import beErrors from '@/mixins/beErrors'
import SimonModal from '@/components/modal/SimonModal.vue'

export const stepName = 'changePayment'

const initialPaymentInformationState = {
  paymentType: 'bankAccount',
  iban: '',
  owner: ''
}

export default {
  name: 'ChangePaymentChangeWrapper',
  components: {
    SimonModal,
    PaymentBankAccount
  },
  data () {
    return {
      paymentType: 'bankAccount',
      payment: [],
      loadingNext: false,
      bankAccountInvalid: false,
      paymentInformation_: initialPaymentInformationState,
      gotBackendError: false
    }
  },
  props: {
    creditCardFrameAddress: {
      type: String
    },
    creditCardRedirectUrl: {
      type: String
    },
    noPaymentPossible: {
      type: Boolean,
      default: true
    },
    paymentInformation: {
      type: Object
    }
  },
  mixins: [
    validationMixin,

    validationFlow,
    syncProperty('show', 'showModal'),
    syncProperty('loading', 'loading_'),
    beErrors
  ],
  computed: {
    getBackendErrorMessage: function () {
      return this.beErrorGetLastMessage()
    },
    getBackendErrorCode: function () {
      return this.beErrorGetLastErrorCode()
    }
  },
  methods: {
    ...mapMutations('changePayment', [
      'changeStep'
    ]),
    ...mapActions('changePayment', [
      'changePayment'
    ]),
    showBackendError () {
      return this.gotBackendError
    },
    onModalShown () {
      this.gotBackendError = false
      this.$store.commit('clearMessages', {}, { root: true })
      this.paymentInformation_.paymentType = this.paymentInformation?.type?.trim()
      this.paymentInformation_.owner = this.paymentInformation?.owner?.trim()
      this.paymentInformation_.iban = ''
    },
    onFormFocus () {
      this.gotBackendError = false
    },
    next () {
      this.$refs.bankAccount.formValidation()

      if (!this.bankAccountInvalid) {
        this.loading_ = true
        this.startLoader()

        this.changePayment({
          changePaymentData: this.paymentInformation_,
          nextStep: nextStep
        })
          .then((response) => {
            if (this.beErrorGetLastErrorCode()) {
              this.gotBackendError = true
            }

            this.loading_ = false
            this.stopLoader()

            if (response === 'success') {
              console.log('change payment successful')
              this.showModal = false
              this.successToast(
                this.$slots.txtChangedPaymentDataSaved
                  ? this.$slots.txtChangedPaymentDataSaved[0].text
                  : 'Die Zahlungsdaten wurden erfolgreich gespeichert.'
              )
            }

            this.$emit('after-change', this.paymentInformation_)
          })
          .catch(() => {
            this.loading_ = false
            this.stopLoader()
            console.error('Technical error occurred')
          })
      } else {
        this.loading_ = false

        // Ensure live feedback for validation errors
        this.vFlowGetFirstErrorElementName().then((result) => {
          const data = {
            type: 'validation',
            message: 'required field missing',
            location: result + ' - unknown'
          }

          if (typeof window.trackingNS?.track?.tracking === 'function') {
            window.trackingNS.track.tracking('error', data)
          }
        })
      }
    },
    prev () {
      this.$store.commit('clearMessages', {}, { root: true })
      this.showModal = false
    }
  }
}
</script>
